(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-shipping-calculator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('shipping-rate-calculator')) {
  customElements.define('shipping-rate-calculator', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.result = this.querySelector('.shipping-calculator__result');
      this.form.addEventListener('submit', this.calculate.bind(this));
    }

    async calculate(event) {
      event.preventDefault();
      const button = this.form.querySelector('button');
      const data = new FormData(this.form);
      const country = data.get('country');
      const zip = data.get('zip').trim();

      if (!zip) return;

      button.disabled = true;
      this.result.textContent = 'Verzendkosten worden berekend…';

      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const params = new URLSearchParams();
      params.set('shipping_address[country]', country);
      params.set('shipping_address[zip]', zip);

      try {
        const response = await fetch(root + 'cart/shipping_rates.json?' + params.toString(), {
          headers: { Accept: 'application/json' }
        });
        const payload = await response.json();

        if (!response.ok) {
          throw new Error('rates_unavailable');
        }

        const rates = payload.shipping_rates || [];
        if (!rates.length) {
          this.result.textContent = 'Geen verzendtarieven gevonden. Controleer de postcode of voeg eerst het product toe aan je winkelmandje.';
          return;
        }

        const list = document.createElement('ul');
        list.className = 'shipping-calculator__rates';

        rates.forEach((rate) => {
          const item = document.createElement('li');
          item.className = 'shipping-calculator__rate';

          const name = document.createElement('span');
          name.textContent = rate.name;

          const price = document.createElement('strong');
          const amount = Number.parseFloat(rate.price);
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
            style: 'currency',
            currency: rate.currency || 'EUR'
          }).format(amount);

          item.append(name, price);
          list.append(item);
        });

        this.result.replaceChildren(list);
      } catch (error) {
        this.result.textContent = 'De verzendkosten konden nu niet worden berekend. Probeer het later opnieuw of bekijk ze bij het afrekenen.';
      } finally {
        button.disabled = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
